/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListConditions200ResponseItemsInner
 */
export interface ListConditions200ResponseItemsInner {
    /**
     * サービス種別
     * @type {number}
     * @memberof ListConditions200ResponseItemsInner
     */
    serviceCategory: ListConditions200ResponseItemsInnerServiceCategoryEnum;
    /**
     * 金銭区分
     * @type {number}
     * @memberof ListConditions200ResponseItemsInner
     */
    moneyCategory: ListConditions200ResponseItemsInnerMoneyCategoryEnum;
    /**
     * 費目名
     * @type {string}
     * @memberof ListConditions200ResponseItemsInner
     */
    expenseItemName: string;
    /**
     * 手数料率
     * @type {number}
     * @memberof ListConditions200ResponseItemsInner
     */
    feePercentage: number;
    /**
     * 税区分
     * @type {number}
     * @memberof ListConditions200ResponseItemsInner
     */
    taxKind: ListConditions200ResponseItemsInnerTaxKindEnum;
    /**
     * 集計期間区分 1=1日〜月末 2=A: 1日〜15日,B: 16日〜月末
     * @type {number}
     * @memberof ListConditions200ResponseItemsInner
     */
    aggregationPeriodKind: ListConditions200ResponseItemsInnerAggregationPeriodKindEnum;
    /**
     * 精算処理日区分 1=翌月1日 2=A: 当月16日,B: 翌月1日
     * @type {number}
     * @memberof ListConditions200ResponseItemsInner
     */
    processingPeriodKind: ListConditions200ResponseItemsInnerProcessingPeriodKindEnum;
    /**
     * 備考
     * @type {string}
     * @memberof ListConditions200ResponseItemsInner
     */
    description?: string;
    /**
     * 経済条件ID
     * @type {number}
     * @memberof ListConditions200ResponseItemsInner
     */
    id: number;
    /**
     * サービス名称
     * @type {string}
     * @memberof ListConditions200ResponseItemsInner
     */
    serviceName?: string;
    /**
     * 更新日時
     * @type {Date}
     * @memberof ListConditions200ResponseItemsInner
     */
    updatedAt: Date;
    /**
     * バージョン番号（経済条件）
     * @type {number}
     * @memberof ListConditions200ResponseItemsInner
     */
    version: number;
}


/**
 * @export
 */
export const ListConditions200ResponseItemsInnerServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type ListConditions200ResponseItemsInnerServiceCategoryEnum = typeof ListConditions200ResponseItemsInnerServiceCategoryEnum[keyof typeof ListConditions200ResponseItemsInnerServiceCategoryEnum];

/**
 * @export
 */
export const ListConditions200ResponseItemsInnerMoneyCategoryEnum = {
    OVERSEAS_APP_PLATFORM_SALES: 0,
    TIP: 1,
    CANCELLATION_FEE: 2,
    TAXIFARE: 3
} as const;
export type ListConditions200ResponseItemsInnerMoneyCategoryEnum = typeof ListConditions200ResponseItemsInnerMoneyCategoryEnum[keyof typeof ListConditions200ResponseItemsInnerMoneyCategoryEnum];

/**
 * @export
 */
export const ListConditions200ResponseItemsInnerTaxKindEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type ListConditions200ResponseItemsInnerTaxKindEnum = typeof ListConditions200ResponseItemsInnerTaxKindEnum[keyof typeof ListConditions200ResponseItemsInnerTaxKindEnum];

/**
 * @export
 */
export const ListConditions200ResponseItemsInnerAggregationPeriodKindEnum = {
    ONCE_MONTH: 1,
    TWICE_MONTH: 2
} as const;
export type ListConditions200ResponseItemsInnerAggregationPeriodKindEnum = typeof ListConditions200ResponseItemsInnerAggregationPeriodKindEnum[keyof typeof ListConditions200ResponseItemsInnerAggregationPeriodKindEnum];

/**
 * @export
 */
export const ListConditions200ResponseItemsInnerProcessingPeriodKindEnum = {
    ONCE_MONTH: 1,
    TWICE_MONTH: 2
} as const;
export type ListConditions200ResponseItemsInnerProcessingPeriodKindEnum = typeof ListConditions200ResponseItemsInnerProcessingPeriodKindEnum[keyof typeof ListConditions200ResponseItemsInnerProcessingPeriodKindEnum];


/**
 * Check if a given object implements the ListConditions200ResponseItemsInner interface.
 */
export function instanceOfListConditions200ResponseItemsInner(value: object): value is ListConditions200ResponseItemsInner {
    if (!('serviceCategory' in value) || value['serviceCategory'] === undefined) return false;
    if (!('moneyCategory' in value) || value['moneyCategory'] === undefined) return false;
    if (!('expenseItemName' in value) || value['expenseItemName'] === undefined) return false;
    if (!('feePercentage' in value) || value['feePercentage'] === undefined) return false;
    if (!('taxKind' in value) || value['taxKind'] === undefined) return false;
    if (!('aggregationPeriodKind' in value) || value['aggregationPeriodKind'] === undefined) return false;
    if (!('processingPeriodKind' in value) || value['processingPeriodKind'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function ListConditions200ResponseItemsInnerFromJSON(json: any): ListConditions200ResponseItemsInner {
    return ListConditions200ResponseItemsInnerFromJSONTyped(json, false);
}

export function ListConditions200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListConditions200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceCategory': json['service_category'],
        'moneyCategory': json['money_category'],
        'expenseItemName': json['expense_item_name'],
        'feePercentage': json['fee_percentage'],
        'taxKind': json['tax_kind'],
        'aggregationPeriodKind': json['aggregation_period_kind'],
        'processingPeriodKind': json['processing_period_kind'],
        'description': json['description'] == null ? undefined : json['description'],
        'id': json['id'],
        'serviceName': json['service_name'] == null ? undefined : json['service_name'],
        'updatedAt': (new Date(json['updated_at'])),
        'version': json['version'],
    };
}

export function ListConditions200ResponseItemsInnerToJSON(json: any): ListConditions200ResponseItemsInner {
    return ListConditions200ResponseItemsInnerToJSONTyped(json, false);
}

export function ListConditions200ResponseItemsInnerToJSONTyped(value?: ListConditions200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'service_category': value['serviceCategory'],
        'money_category': value['moneyCategory'],
        'expense_item_name': value['expenseItemName'],
        'fee_percentage': value['feePercentage'],
        'tax_kind': value['taxKind'],
        'aggregation_period_kind': value['aggregationPeriodKind'],
        'processing_period_kind': value['processingPeriodKind'],
        'description': value['description'],
        'id': value['id'],
        'service_name': value['serviceName'],
        'updated_at': ((value['updatedAt']).toISOString()),
        'version': value['version'],
    };
}

